const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    }
};
$('body').on('click', '.btn-upload', function () {
    var $button = $(this);
    var url = $button.data('url');
    var $modal = $('#upload-modal');
    var modalEl = $modal.get(0);

    $modal.find('iframe').attr('src', url);

    if (modalEl) {
        modalEl.dataset.cartLineId = this.dataset.cartLineId || '';
        modalEl.dataset.orderLineId = this.dataset.orderLineId || '';
        modalEl.dataset.productionNotes = this.dataset.productionNotes || '';
    }

    $modal
        .off('hidden.bs.modal.uploadReload')
        .on('hidden.bs.modal.uploadReload', function () {
            location.reload();
        });
});
$('#enable-campione').on('click', function (ev) {
    orderCampione(ev, true);
});
$('#disable-campione').on('click', function (ev) {
    orderCampione(ev, false);
});
$('#enable_four_percent_vat,#enable_four_percent_vat_mobile').on(
    'click',
    function (ev) {
        enableFourPercentVat();
    }
);
$(document).on(
    'click',
    '.posizioni-checkbox :not(.no-stampa) .prodottiprint-inputcheckboxbutton',
    function () {
        if (isMobile.any()) {
            setTimeout(() => {
                scrollTo(
                    '.anchorDimensioni .prodottiprint-radiobutton:first .prodottiprint-radiobutton-text',
                    80
                );
            }, 1);
        } else {
            setTimeout(() => {
                scrollTo('.prodotti-print-blocco .help-text', 0);
            }, 1);
        }
    }
);
$(document).on('click', '.prodottiprint-colorchoose span', function () {
    if (isMobile.any()) {
        setTimeout(() => {
            scrollTo('.img-prodotto-wrapper');
        }, 100);
    }
});
$(document).on(
    'click',
    '.lavorazioniGroup .prodottiprint-inputradiobutton',
    function () {
        if (isMobile.any())
            $('html,body').animate(
                { scrollTop: $(window).scrollTop() + 110 },
                1
            );
        else
            $('html,body').animate(
                { scrollTop: $(window).scrollTop() + 60 },
                1
            );
    }
);
/*$(document).on('click',".anchorDimensioni .prodottiprint-inputradiobutton",function(){
    if(isMobile.any())
        $("html,body").animate({ scrollTop: $(window).scrollTop() + 110 }, 1);
    else
        $("html,body").animate({ scrollTop: $(window).scrollTop() + 60 }, 1);
});*/

function localizedValidationMessage(element) {
    var messages = document.documentElement.dataset;

    element.setCustomValidity('');

    if (element.validity.valueMissing) {
        return messages.validationRequired;
    }

    if (element.validity.typeMismatch && element.type === 'email') {
        return messages.validationEmail;
    }

    if (!element.validity.valid) {
        return messages.validationInvalid;
    }

    return '';
}

function validateFormInput(element) {
    var message = localizedValidationMessage(element);

    if (message) {
        element.setCustomValidity(message);
        $(element).addClass('is-invalid');
        $(element).siblings('.invalid-feedback').text(message);
    } else {
        $(element).removeClass('is-invalid');
        $(element).siblings('.invalid-feedback').text('');
    }
}

var validatedFormFields =
    '.form-label-group input, .form-label-group select, .form-label-group textarea, .form-check input';

$(document).on('blur', validatedFormFields, function () {
    validateFormInput(this);
});

$(document).on('input change', validatedFormFields, function () {
    this.setCustomValidity('');

    if ($(this).hasClass('is-invalid')) {
        validateFormInput(this);
    }
});

document.addEventListener(
    'invalid',
    function (event) {
        if (event.target.matches(validatedFormFields)) {
            validateFormInput(event.target);
        }
    },
    true
);

// megamenu
document.addEventListener('DOMContentLoaded', function () {
    // Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function (element) {
        element.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    });
});

// overlay chiaro megamenu
document.addEventListener('DOMContentLoaded', function () {
    document
        .querySelectorAll('.navbar .dropdown')
        .forEach(function (everydropdown) {
            everydropdown.addEventListener('shown.bs.dropdown', function () {
                el_overlay = document.createElement('span');
                el_overlay.className = 'screen-lighten';
                document.body.appendChild(el_overlay);
            });

            everydropdown.addEventListener('hide.bs.dropdown', function () {
                document.body.removeChild(
                    document.querySelector('.screen-lighten')
                );
            });
        });
});

$(document).on('focus', '.select2.select2-container', function (e) {
    // only open on original attempt - close focus event should not fire open
    if (
        e.originalEvent &&
        $(this).find('.select2-selection--single').length > 0
    ) {
        $(this).siblings('select').select2('open');
    }
});

document.addEventListener('search-content-loaded', function (e) {
    $(document).on('shown.bs.modal', '#searchModal', function () {
        $('#search-input').focus();
    });

    $('#search-button').click(function (e) {
        let query = $('#search-input').val();
        search(query, 1);
    });

    let debounceTimer;
    $('#search-input').on('input', function () {
        clearTimeout(debounceTimer);
        const query = $(this).val();

        debounceTimer = setTimeout(function () {
            search(query, 1);
        }, 300);
    });

    $('#search-results').on('click', '.page-link', function (e) {
        let element = $(e.target);
        if ($(e.target).is('i')) {
            element = $(e.target).parent();
        }

        let query = $('#search-input').val();
        search(query, element.data('href').split('page=')[1]);
    });

    function search(query, page) {
        let trimmed = query.trim();

        if (trimmed.length === 0) {
            $('#search-results').html('').hide();
            $('#search-spinner').hide();
            return;
        }

        $('#search-results').hide();
        $('#search-spinner').show();

        if (trimmed.length < 3) {
            $('#search-spinner').hide();
            $('#search-results').html('').hide();
            return;
        }

        axios
            .post('/search', {
                query: trimmed,
                page: page
            })
            .then(function (response) {
                $('#search-spinner').hide();
                $('#search-results').html(response.data).fadeIn(150);
                highlightSearchTerm(trimmed);
            })
            .catch(function () {
                $('#search-spinner').hide();
                $('#search-results').html('').fadeIn(150);
            });
    }

    function highlightSearchTerm(term) {
        if (!term) return;

        const safeTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${safeTerm})`, 'gi');

        $('#search-results .results__item__text .h5').each(function () {
            const original = $(this).text();
            const highlighted = original.replace(regex, '<strong>$1</strong>');
            $(this).html(highlighted);
        });
    }
});

if ($('.infinite-scroll').length > 0) {
    $('ul.pagination').hide();
    $('.infinite-scroll').jscroll({
        autoTrigger: true,
        loadingHtml:
            '<div class="text-center pt-2"><i class="fa-solid fa-spinner fa-spin-pulse fa-2x"></i></div>',
        padding: 0,
        nextSelector: '.pagination li.active + li a',
        contentSelector: 'div.infinite-scroll',
        callback: function () {
            $('ul.pagination').remove();
        }
    });
}

$.ajaxSetup({
    complete: function () {
        bindImageErrorToLocal();
    }
});

$(document).ready(function () {
    bindImageErrorToLocal();
});

function bindImageErrorToLocal() {
    $('img').on('error', function () {
        const imageLocalPath = $(this).data('image-local');
        $(this).unbind('error');
        if ($(this).hasClass('lazyloaded') || $(this).hasClass('lazyloading')) {
            //L'errore è scattato dopo che l'immagine è stata lazyloadata, quindi devo caricarla subito
            $(this).attr('src', imageLocalPath);
            $(this).attr('data-bgset', imageLocalPath);
            $(this)
                .siblings()
                .each(function () {
                    $(this).attr('srcset', imageLocalPath);
                });
        } else {
            $(this).attr('data-src', imageLocalPath);
            $(this).attr('data-bgset', imageLocalPath);
            $(this)
                .siblings()
                .each(function () {
                    $(this).attr('data-srcset', imageLocalPath);
                });
        }
    });
}
function orderCampione(ev, enableDIsable) {
    ev.preventDefault();
    ev.stopPropagation();
    let message;
    if (enableDIsable) {
        message = 1;
        $('#enable-campione').hide();
        $('#disable-campione').show();
    } else {
        message = 0;
        $('#enable-campione').show();
        $('#disable-campione').hide();
    }
    const customEvent = new CustomEvent('ordinaCampioneEvents', {
        detail: {
            message: message
        }
    });
    window.dispatchEvent(customEvent);
}
function enableFourPercentVat() {
    let message = 0;
    if (
        $('#enable_four_percent_vat,#enable_four_percent_vat_mobile').is(
            ':checked'
        )
    ) {
        message = 1;
    }
    const customEvent = new CustomEvent('enableFourPercentVat', {
        detail: {
            message: message
        }
    });
    window.dispatchEvent(customEvent);
}
function scrollTo(el, scrollMinus = 0) {
    if (el && $(el).length) {
        let headerHeight = 0;
        if ($('.header-container').length)
            headerHeight = $('.header-container').height();

        $('html,body').animate(
            { scrollTop: $(el).offset().top - headerHeight - scrollMinus },
            1
        );
    }
}

// Smooth scroll al click, con offset che tiene conto dell'altezza header
$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    const headerHeight = $('.widget-header').outerHeight() || 0;
    const extraSpace = 32; // Aggiungo 32px extra

    $('html, body').animate(
        {
            scrollTop:
                $($.attr(this, 'href')).offset().top -
                (headerHeight + extraSpace)
        },
        100
    );
});

$(document).ready(function () {
    $('body').tooltip({
        selector: '[data-bs-toggle="tooltip"]'
    });
});
